import React from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import StefanTimeChartGeneric from "../components/Admin/StefanTimeChartGeneric";
import { auth } from "../firebaseConfig";

const PROGRESS_LABELS = {
  mai: "MAI",
  mapn: "MApN",
  anp: "ANP",
  isu: "ISU",
};

const ProgressCategoryPage = () => {
  const { category = "" } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const slug = category.toLowerCase();
  const label = PROGRESS_LABELS[slug];
  const targetUid = searchParams.get("userId") || auth.currentUser?.uid || null;
  const targetName = searchParams.get("userName") || null;
  const targetEmail =
    searchParams.get("userEmail") || auth.currentUser?.email || null;

  if (!label) {
    return (
      <div
        className="min-h-screen flex items-center justify-center px-4"
        style={{ backgroundColor: "var(--color-bg)", color: "var(--color-text)" }}
      >
        <div className="max-w-lg w-full text-center space-y-4">
          <h1 className="text-3xl font-bold">Categoria nu există</h1>
          <p style={{ color: "var(--color-text-secondary, #6b7280)" }}>
            Verifică linkul sau alege o categorie validă (MAI, MApN, ANP, ISU).
          </p>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-3 rounded-lg font-semibold bg-orange-500 text-white hover:bg-orange-600 transition"
          >
            Înapoi
          </button>
        </div>
      </div>
    );
  }

  const collectionSuffix = slug;
  const accent = "var(--color-accent)";

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: "var(--color-bg)", color: "var(--color-text)" }}
    >
      <div className="max-w-5xl mx-auto px-4 py-10 space-y-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-orange-500">
              Progres {label}
            </p>
            <h1 className="text-3xl font-bold">
              Urmărire Progres{" "}
              {targetName ? `${targetName} - ${label}` : label}
            </h1>
            <p
              className="text-sm mt-1"
              style={{ color: "var(--color-text-secondary, #6b7280)" }}
            >
              Introdu timpii și vizualizează evoluția pentru categoria selectată.
            </p>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-3 rounded-lg font-semibold border transition"
            style={{
              borderColor: "var(--color-border, #d1d5db)",
              color: "var(--color-text-secondary, #6b7280)",
            }}
          >
            Înapoi
          </button>
        </div>

        <div className="space-y-6">
          <StefanTimeChartGeneric
            title="Timp Rezistență + Dată"
            valueLabel="Rezistență"
            collectionName={`rezistentaData_${collectionSuffix}`}
            color={accent}
            filterUid={targetUid}
            filterEmail={targetEmail}
            overrideUid={targetUid}
            overrideEmail={targetEmail}
          />

          <StefanTimeChartGeneric
            title="Timp Traseu + Dată"
            valueLabel="Traseu"
            collectionName={`traseuData_${collectionSuffix}`}
            color={accent}
            filterUid={targetUid}
            filterEmail={targetEmail}
            overrideUid={targetUid}
            overrideEmail={targetEmail}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressCategoryPage;
